// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dbb11363","455":"378cf3bb","977":"b06a1302"}[chunkId] + ".chunk.js";
};